import { Box, Container, Typography } from '@mui/material';
import { LibraryManagement } from 'components/templates';
import React from 'react';

export const LibraryView = () => {
  return (
    <Container component="main" maxWidth="xl" sx={{ width: '75%' }}>
      <Box>
        <Typography variant="h4" gutterBottom sx={{ textAlign: 'left' }}>
          My Library
        </Typography>
      </Box>
      <LibraryManagement />
    </Container>
  );
};
